import React from "react"
import { SurveyAnswer } from "../../../../domain/entities/SurveyAnswer"
import { SurveysViewModel } from "../SurveysViewModel"
import SurveyAnswersGroupedTable from "./SurveyAnswersGroupedTable"
import { SurveySection } from "../../../../domain/entities/SurveySection"

interface SurveyResponsesSectionProps {
	answers: SurveyAnswer[]
	sections?: SurveySection[]
	viewModel: SurveysViewModel
}

const SurveyResponsesSection: React.FC<SurveyResponsesSectionProps> = ({ answers, sections, viewModel }) => {
	return (
		<div>
			<SurveyAnswersGroupedTable data={answers} sections={sections} viewModel={viewModel} />
		</div>
	)
}

export default SurveyResponsesSection
